@let corporateDesign = corporateDesignService.corporateDesign();
@let texts = textStore.texts();
@let fontColor =
  corporateDesignService.isDarkModeActive()
    ? corporateDesign.colorAdmixtures.dark_text_high
    : '';

@if (fellowTravelerStore.isActive()) {
  @if (fellowTravelerStore.isLoading() && corporateDesign) {
    <div class="loading-spinner"></div>
  } @else {
    <aw-section
      class="w-full"
      testIdAffix="account-fellow-travelers-form"
      [darkModeColor]="corporateDesign.colorAdmixtures.dark_surface_01">
      <aw-section-header>
        <aw-section-headline class="font-semibold">{{
          texts
            | filterTexts
              : ERelationType.fellowTravelersLabel
              : EEntityType.privateArea
            | language
        }}</aw-section-headline>
      </aw-section-header>
      <div class="flex flex-col gap-3">
        @for (
          fellowTraveler of fellowTravelerStore.fellowTravelers();
          track fellowTraveler.id
        ) {
          <aw-account-fellow-traveler-item
            [fellowTraveler]="fellowTraveler"
            [corporateDesign]="corporateDesign"
            [fontColor]="fontColor"
            [texts]="texts" />
        }
      </div>
      @if (isCreating()) {
        <aw-account-fellow-traveler-item
          [fellowTraveler]="createFellowTraveler()"
          [corporateDesign]="corporateDesign"
          [fontColor]="fontColor"
          [texts]="texts"
          (creationFinished)="finishCreatingFellowTraveler()" />
      }
      <aw-button
        (keyup.enter)="createNewFellowTraveler()"
        (click)="createNewFellowTraveler()"
        [isDisabled]="isCreating()"
        id="fellow-traveler-create"
        type="button"
        >{{
          texts
            | filterTexts
              : ERelationType.createFellowTravelerButtonText
              : EEntityType.privateArea
            | language
        }}</aw-button
      >
    </aw-section>
  }
}
